import React, { FC } from "react"
import * as S from "./elements"
import { PopularProducts } from "./PopularProducts"
import { RecentlyViewed } from "./RecentlyViewed"

type FeaturedProductsProps = {
  popularProducts: string[]
}

export const FeaturedProducts: FC<FeaturedProductsProps> = ({
  popularProducts,
}) => {
  return (
    <S.Container>
      <S.Column>
        <PopularProducts items={popularProducts} />
      </S.Column>
      <S.Column>
        <RecentlyViewed />
      </S.Column>
    </S.Container>
  )
}
